import React from 'react';
import { motion } from 'framer-motion';
export function Objections() {
  return <section className="py-8 bg-white" data-id="element-99">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#F8F3EA] p-10 rounded-3xl border border-[#D4AF37]/20" data-id="element-101">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2B0A3D] mb-4" data-id="element-102">
            ¿Y si soy inconstante?
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed" data-id="element-103">
            Por eso es por fases. No necesitas perfección. Solo seguir el día
            que toca.
          </p>
        </motion.div>
      </div>
    </section>;
}